var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 6,
    viewBox: "0 0 24 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 6,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAGCAYAAADZq14TAAAA8klEQVQokbWRQU7CQBSGvzfaNmrCDfQCwoqYgJUFG+QoeoEuFXdyAO+irFy0MYSwQk6gVyCklc6YmVYSM3Xpt/uTf/437/2CJex3gDYHu5Tt4oNGugFRMAYx5MULLL8abUdXZ5RlDLxTvK2EoHeDyBOggA1aj9nN09+vzkPC1ivQd1LIyIuhN+QwHqD0M3AMaIzcKkTu6nDLCUol3q+i1mgfbjHERNHI8ymd1OFOIeZeOfv/YRRGHtw6FRs0j944e3N7lh9EUvJ85vm0nrqMWmHMpC75sl2VXKZs55/N+9iSw+uqZBv+V8kXp5RBDLKiyNbfvR1NqyvKzBoAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.0c32321e54b1262bcef7b82878fd6889.svg";
export { ForwardRef as ReactComponent };